import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // This gets the current page's path (e.g., "/" or "/stadiums")
  const { pathname } = useLocation();

  // This hook runs every single time the 'pathname' changes
  useEffect(() => {
    // It scrolls the window to the top
    window.scrollTo(0, 0);
  }, [pathname]); // The effect re-runs when the path changes

  return null; // This component doesn't render any HTML
};

export default ScrollToTop;